// extracted by mini-css-extract-plugin
export default {"messagesList":"messages-list_messagesList__CchWx","messages":"messages-list_messages__pZhhx","newMessagePopup":"messages-list_newMessagePopup__+IUFi"};